import React from 'react';


// WhyMonthly component to be used in the panel
const WhyMonthly = (props)=>{
    const {title,message,imgUrl} = props.item;
    return(
        <main className="why-monthly-component">
            <div className="why-monthly-content">
                <img src={imgUrl} className="why-monthly-image" alt="Image Here"/>
                <p className="why-monthly-title">{title}</p>
                <p className="why-monthly-description">
                    {message}
                </p>

            </div>
            <style jsx>
               {
                   `
                   .why-monthly-component{
                       width:49%;
                       display:flex;
                       min-height:300px;
                       padding:1rem;
                       justify-content:center;
                   }
                   .why-monthly-content{
                       width:80%;
                       height:auto;
                       text-align:center;
                   }

                   .why-monthly-title{
                       font-size:24px;
                   }
                   .why-monthly-image{
                       height:90px;
                       max-height:100%;
                       width:auto;
                       margin-bottom: 1rem;

                   }

                   @media (max-width:767px){
                        .why-monthly-component{
                           width:100%;
                           min-height:auto;
                        }
                        
                        .why-monthly-content{
                            width:100%;
                        }

                        .why-monthly-image{
                            display:none;
                        }

                        .why-monthly-description::after{
                            content:"";
                            display:block;
                            height:1px;
                            width:70px;
                            background:#000;
                            margin:0 auto;
                            margin-top:1rem;
                        }
                    }
                   `
               }

            </style>
        </main>
    )
}

export default WhyMonthly;
